import { TaskDtoType } from '@convergence/client';
import { Table } from '@convergence/components';
import { format } from 'date-fns';
import { useSearchParams } from 'react-router-dom';
import { TaskLogs } from './TaskLogs';

export interface TaskGroupDetailProps {
  analysisSlug: string;
  name: string;
  tasks: TaskDtoType[];
}

export function TaskGroupDetail(props: TaskGroupDetailProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedTaskId = searchParams.get('taskId');
  return (
    <div className="h-full flex flex-col gap-4">
      <Table
        data={props.tasks}
        hide={{ id: true, analysisId: true }}
        row={({ children }, { id }) => (
          <tr
            className={`border-b cursor-pointer hover:bg-gray-200 `}
            onClick={() => {
              searchParams.set('taskId', id.toString());
              setSearchParams(searchParams);
            }}
          >
            {children}
          </tr>
        )}
        cell={({ children }) => (
          <td className="border px-4 py-2 border-black">{children}</td>
        )}
        render={{
          cost({ cost }) {
            // @ts-ignore
            return `$${cost.toFixed(2)}`;
          },
          startedAt(rowData) {
            return rowData.endedAt
              ? format(new Date(rowData.startedAt), 'MM-dd-yyyy - KK:mmaaa')
              : 'N/A';
          },
          endedAt(rowData) {
            return rowData.endedAt
              ? format(new Date(rowData.endedAt), 'MM-dd-yyyy - KK:mmaaa')
              : 'N/A';
          }
        }}
      />
      {!selectedTaskId && (
        <div className="p-4 border border-gray-300 rounded">
          <p className="text-gray-500">Select a task to view logs</p>
        </div>
      )}
      {selectedTaskId && (
        <TaskLogs
          name={props.name}
          index={props.tasks.findIndex((t) => t.id === selectedTaskId) ?? 0}
          taskId={selectedTaskId}
        />
      )}
    </div>
  );
}
